export default __webpack_public_path__ + "static/media/Upload.cd672780.svg";